import React from 'react';
import { useSelector } from 'react-redux';
import { theme } from 'antd';
import { RootState } from 'store/configureStore';
import { TitleList } from 'store/ducks/globalTypes';
import TitleBar from 'components/TitleBar';
import CardComponent from 'components/CardComponent';
import { useDashboardTrees } from 'constants/dashboardTrees';
import * as Styled from '../Layout.styled';
import { useTranslation } from 'react-i18next';

const { useToken } = theme;

type Props = {
  children?: React.ReactNode;
};

const DashboardLayout: React.FC<Props> = ({ children }) => {
  const { token } = useToken();
  const { scheme } = useSelector((state: RootState) => state.global);
  const areas = useDashboardTrees();
  const { t } = useTranslation();

  return (
    <Styled.StyledLayout token={token}>
      <TitleBar title={t(TitleList.DASHBOARD)} />

      <Styled.HorizontalLayoutMain theme={scheme}>
        <Styled.Container>
          <Styled.GridContainer token={token}>
            {areas.map((item: any, index: number) => (
              <Styled.CardItemWrapper key={item.area}>
                <CardComponent
                  area={item.title}
                  infoText={item.infoText}
                  href={item.href}
                  textOnTop=""
                  minHeight="100px"
                />
              </Styled.CardItemWrapper>
            ))}
          </Styled.GridContainer>
        </Styled.Container>
      </Styled.HorizontalLayoutMain>
    </Styled.StyledLayout>
  );
};

export default DashboardLayout;
